import React from 'react'
import { Link } from 'react-router-dom'

import { classNames } from '@/utils/classNames'

export default function Button({ link, to, modifier = 'primary', children, className, type, rounded = 'rounded', onClick, disabled = false }) {
  const styles = {
    primary: `bg-gradient-to-b via-yellow-500 from-yellow-500 to-yellow-600 text-gray-900 ${!disabled ? 'hover:bg-blue-700' : 'opacity-75'}`,
    secondary: `bg-gradient-to-b from-purple-500 to-purple-600 ${!disabled ? 'hover:bg-gray-600' : 'opacity-75'}`,
    tertiary: `bg-gray-900 ${!disabled ? 'hover:bg-gray-900' : 'opacity-75'}`,
    gray: `bg-gray-700`,
    danger: `bg-red-600 ${!disabled ? 'hover:bg-red-700' : 'opacity-75'}`,
    success: `bg-green-600 ${!disabled ? 'hover:bg-green-700' : 'opacity-75'}`,
  }[modifier]
  

  if (link && to) {
    return (
      <Link to={to} className={`tracking-tight relative block transition duration-300 text-sm text-white font-medium shadow-lg flex items-center justify-center ${styles} ${rounded} ${className}`}>
        <span>{children}</span>
      </Link>
    )
  }

  return (
    <button disabled={disabled} onClick={onClick} type={type ? type : 'button'} className={classNames('tracking-tight overflow-hidden relative flex items-center justify-center transition duration-300 text-sm text-white font-medium shadow-lg py-2.5', styles, rounded, className, disabled ? 'cursor-not-allowed' : '')}>
      <span>{children}</span>
    </button>
  )
}